import React from 'react';

import * as S from './styles';

export const Header = ({ isPremiumPro }) => {
  return isPremiumPro ? <S.WrapperPro></S.WrapperPro> : <S.Wrapper></S.Wrapper>;
};
